import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { Message } from "../../../@types/message";
import axios from "axios";
import { RootState } from "../../rootReducer";
import axiosInstance from "../../../utils/axiosConfig";
export const findMessages = createAsyncThunk(
  "users/findMessages",
  async (searchText, { rejectWithValue, getState }) => {
    const state = getState() as RootState;
    try {
      const { data } = await axiosInstance.get(`${api.baseURL}message`, {
        params: {
          sort: "createdAt DESC",
          populate: ["createdBy", "document"].join(","),
          where:{
            sourceOrganization: state.userAuthentication.user?.sourceOrganization,
          }
        },
      });
      return data as Message[];
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
